export default class Search {
    constructor(elm, args) {
        this.elm = elm;
        this.input = elm.querySelector('[data-search-input]');
        this.culture = this.input.dataset.searchCulture;
        this.searchResults = elm.querySelector('[data-search-results]');

        this.input.addEventListener('input', this.debounce((e) => {
            this.getTypeAHead(e.target.value, this.culture).then(data => {
                console.log('search input changed', data);
                let html = '';

                data.forEach(item => html += `<a class="${args.resultClass}" href="${item.Url}">${item.Result}</a>`);

                this.searchResults.innerHTML = html;

                //this.trap.update(Array.from(this.overlay.querySelectorAll(this.trap.focusableElements)));
            });
        }, 500));
    }

    debounce(callback, wait) {
        return (...args) => {
            window.clearTimeout(this.debounceTimer);
            this.debounceTimer = window.setTimeout(() => callback.apply(null, args), wait);
        };
    }

    getTypeAHead(q, culture) {
        return new Promise((resolve) => {
            if (q === '' || q.length < 3) {
                resolve([]);
            } else {
                fetch(`/umbraco/api/search/typeahead?q=${q}&culture=${culture}`, {
                    method: 'GET',
                    cache: 'no-cache',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then(response => response.json())
                    .then(data => resolve(data))
                    .catch(data => {
                        throw new Error(data)
                    });
            }
        });
    }
}
